var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.92 12.3699C21.79 12.7199 22.33 13.7499 22.13 14.6599L21.72 16.5199C21.01 19.7199 18.5 21.9999 14.88 21.9999H10.12C6.49998 21.9999 3.98999 19.7199 3.27999 16.5199L2.86998 14.6599C2.66998 13.7499 3.20997 12.7199 4.07997 12.3699L5.49999 11.7999L11.01 9.58993C11.97 9.20993 13.03 9.20993 13.99 9.58993L19.5 11.7999L20.92 12.3699Z",
    stroke: "#4F5B92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22V10",
    stroke: "#4F5B92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8V11.8L13.99 9.59C13.03 9.21 11.97 9.21 11.01 9.59L5.5 11.8V8C5.5 6.35 6.85 5 8.5 5H16.5C18.15 5 19.5 6.35 19.5 8Z",
    stroke: "#4F5B92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H10V3C10 2.45 10.45 2 11 2H14C14.55 2 15 2.45 15 3V5Z",
    stroke: "#4F5B92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.47d0a581a63c1647298fc550c5787315.svg";
export { ForwardRef as ReactComponent };